// extracted by mini-css-extract-plugin
module.exports = {"download":"DownloadIcon_download__3ShWa"};